import { gql } from "@apollo/client";


export const GET_PROFILE = gql`
query Me {
  me {
    _id
    firstName
    lastName
    profileImage
    email
    mobile
    emailProvider
    textProvider
    tested
    smtpTested
    role
    roleName
    paid
    planType
    expirationDate
    planExpired
    isActive
    softDelete
  }
}
`

export const GET_DASHBOARD_CHECK = gql`
query GetUserDashboardData {
  getUserDashboardData {
    _id
    campaignCreated
    campaignSent
    emailProvider
    emailVerified
  }
}
`
